import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals, AuthenData } from '../globals/globals';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import { CustomerProfileResponse, ProvinceResponse, CustomerRequest, CustomerResponse } from '../model/criteria/customer';


@Injectable()
export class CustomerService {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();
    constructor(private http: HttpClient, private global: Globals) { }

    public getCustomerNo(): any {
      return JSON.parse(localStorage.getItem('customerNo'));
  }


    find(criteria): Observable<CustomerProfileResponse> {
        return this.http.post<CustomerProfileResponse>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerProfile', criteria)
    }

    findById(criteria): Observable<CustomerProfileResponse> {
      return this.http.post<CustomerProfileResponse>(this.global.BaseApiUrl + 'api/Customer/Management/GetCustomerProfileByID', criteria)
  }

    findList(criteria): Observable<CustomerResponse> {
        return this.http.post<CustomerResponse>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerList', criteria)
    }

    findSetting(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerSetting', criteria)
    }

    findHead(criteria): Observable<CustomerProfileResponse> {
        return this.http.post<CustomerProfileResponse>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerHeadProfile', criteria)
    }

    findProvince(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/Province', criteria)
    }

    findMenuSystemGroup(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/GetMenuSystemGroup', criteria)
    }

    saveSetting(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/Setting', criteria)
    }

    updateSetting(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/UpdateSetting', criteria)
    }

    findDueDate(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/CustomerDueDate', criteria)
    }

    findBank(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/BankSystem', criteria)
  }

  updateBank(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Customer/Management/UpdateSettingBank', criteria)
}
}





// WEBPACK FOOTER //
// ./src/app/services/customer.services.ts